import React, { useState, useEffect } from 'react';
import { useToolContext, setTool } from '../Contexts/ToolContext';

export default function Toolbar() {
  const [activeTool, setActiveTool] = useState('selector');
  const { tool, dispatch } = useToolContext();

  useEffect(() => {
    $(document).on('switchTool', (el) => {
      console.log(el.tool);
      dispatch(setTool(el.tool));
      setActiveTool(el.tool);
    });
  }, []);
  console.log(activeTool);
  return (
    // <div className={`${!show && 'hidden'} bg-white h-20 rounded-md w-full`}>
    <div className={`bg-white h-3/5 shadow-lg rounded-md !z-[1001] fixed w-14 top-1/2 left-5 transform -translate-y-1/2 mt-[30px]`}>
      <div className="relative h-full grid items-center">
        <div className="relative flex justify-evenly flex-col items-center h-full">
          <svg
            onClick={() => setActiveTool('selector')}
            id="selector"
            type="image/svg+xml"
            className={`tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100  ${
              activeTool === 'selector' ? `!fill-header hover:fill-header` : 'hover:fill-slate-900'
            }`}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="271.81298828125 214.97999572753906 208.375 322.0369873046875"
          >
            <path d="m308.61 214.98c-12.32 94.625-24.555 189.26-36.797 283.9l76.195-41.953 21.223 80.09 45.258-12.262-21.184-79.949 86.883-1.6211c-57.27-76.008-114.42-152.11-171.58-228.2z"></path>
          </svg>
          <svg
            onClick={() => setActiveTool('text')}
            id="text"
            type="image/svg+xml"
            className={`tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 ${
              activeTool === 'text' ? `!fill-header hover:fill-header` : 'hover:fill-slate-900'
            }`}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="218.1409912109375 178.67999267578125 315.724365234375 394.64984130859375"
          >
            <path d="m474.66 178.68h-197.32c-15.703 0-30.758 6.2383-41.859 17.34-11.102 11.102-17.34 26.156-17.34 41.859v59.199h39.465v-59.199c0-5.2344 2.0781-10.254 5.7812-13.953 3.6992-3.7031 8.7188-5.7812 13.953-5.7812h78.93v315.72h-59.199v39.465h157.86v-39.465h-59.195v-315.72h78.93c5.2344 0 10.254 2.0781 13.953 5.7812 3.6992 3.6992 5.7812 8.7188 5.7812 13.953v59.199h39.465v-59.199c0-15.703-6.2383-30.758-17.34-41.859-11.102-11.102-26.16-17.34-41.859-17.34z"></path>
          </svg>
          <div className="inline-flex items-center">
            <svg
              onClick={() => setActiveTool('fence-standard')}
              id="fence-standard"
              type="image/svg+xml"
              className={`peer tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 flex ${
                activeTool === 'fence-standard' ? `!fill-header hover:fill-header` : 'hover:fill-slate-900'
              }`}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="139.21600341796875 203.10025024414062 473.60858154296875 345.8097229003906"
            >
              <g>
                <path d="m288.79 548.91v-55.816h-55.816v55.816h-59.742v-55.816h-34.016v-42.301h34.016v-111.2h-34.016v-42.734h34.016v-64.102c0-7.8477 3.4883-15.262 8.7227-20.934h0.4375c5.2344-5.2344 12.645-8.7227 20.934-8.7227 8.2852 0 15.699 3.4883 20.934 8.7227 5.668 5.668 8.7227 13.082 8.7227 20.934v64.102h55.816v-64.102c0-7.8477 3.0508-15.262 8.7227-20.934 5.2344-5.2344 12.645-8.7227 20.934-8.7227 8.2852 0 15.699 3.4883 20.934 8.7227h0.4375c5.2344 5.668 8.7227 13.082 8.7227 20.934v64.102h55.383v-64.102c0-7.8477 3.0508-15.262 8.7227-20.934 5.2344-5.2344 12.645-8.7227 20.934-8.7227 8.2852 0 15.699 3.4883 21.367 8.7227 5.2344 5.668 8.7227 13.082 8.7227 20.934v64.102h55.383v-64.102c0-7.8477 3.4883-15.262 8.7227-20.934 5.668-5.2344 13.082-8.7227 20.934-8.7227 8.2852 0 15.699 3.4883 21.367 8.7227 5.2344 5.668 8.7227 13.082 8.7227 20.934v64.102h34.016v42.734h-34.016v111.2h34.016v42.301h-34.016v55.816h-59.742v-55.816h-55.383v55.816h-59.742v-55.816h-55.383v55.816zm230.25-98.117v-111.2h-55.383v111.2zm-230.25-111.2h-55.816v111.2h55.816zm115.12 0h-55.383v111.2h55.383z"></path>
              </g>
            </svg>

            <div
              class="hidden justify-evenly items-center peer-hover:flex flex-row hover:flex
         w-[100px]
          bg-white absolute h-12 left-10 mt-3 !z-[991]"
            >
              <div
                onClick={() => {
                  setActiveTool('fence-existing');
                  $.event.trigger({
                    type: 'switchTool',
                    tool: 'fence-existing'
                  });
                }}
                id="singleFixedGate-4"
                type="image/svg+xml"
                className="h-full p-1 overflow-hidden flex flex-col items-center place-content-end cursor-pointer"
              >
                <svg
                  className={`tool max-w-[25px] max-h-[25px] transform hover:scale-110 duration-100 ${
                    activeTool === 'fence-existing' ? `!fill-header hover:fill-[${require('../config.json').primary}]` : 'hover:fill-slate-900'
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="139.21600341796875 203.10025024414062 473.60858154296875 345.8097229003906"
                >
                  <g>
                    <path d="m288.79 548.91v-55.816h-55.816v55.816h-59.742v-55.816h-34.016v-42.301h34.016v-111.2h-34.016v-42.734h34.016v-64.102c0-7.8477 3.4883-15.262 8.7227-20.934h0.4375c5.2344-5.2344 12.645-8.7227 20.934-8.7227 8.2852 0 15.699 3.4883 20.934 8.7227 5.668 5.668 8.7227 13.082 8.7227 20.934v64.102h55.816v-64.102c0-7.8477 3.0508-15.262 8.7227-20.934 5.2344-5.2344 12.645-8.7227 20.934-8.7227 8.2852 0 15.699 3.4883 20.934 8.7227h0.4375c5.2344 5.668 8.7227 13.082 8.7227 20.934v64.102h55.383v-64.102c0-7.8477 3.0508-15.262 8.7227-20.934 5.2344-5.2344 12.645-8.7227 20.934-8.7227 8.2852 0 15.699 3.4883 21.367 8.7227 5.2344 5.668 8.7227 13.082 8.7227 20.934v64.102h55.383v-64.102c0-7.8477 3.4883-15.262 8.7227-20.934 5.668-5.2344 13.082-8.7227 20.934-8.7227 8.2852 0 15.699 3.4883 21.367 8.7227 5.2344 5.668 8.7227 13.082 8.7227 20.934v64.102h34.016v42.734h-34.016v111.2h34.016v42.301h-34.016v55.816h-59.742v-55.816h-55.383v55.816h-59.742v-55.816h-55.383v55.816zm230.25-98.117v-111.2h-55.383v111.2zm-230.25-111.2h-55.816v111.2h55.816zm115.12 0h-55.383v111.2h55.383z"></path>
                  </g>
                </svg>
                <p className="text-xs p-0 m-0">Existing</p>
              </div>
            </div>
          </div>
          <div className="inline-flex items-center">
            <svg
              onClick={() => {
                setActiveTool('singleFixedGate-4');
                // $.event.trigger({
                //   type: "switchTool",
                //   tool: "rotate-1",
                // });
              }}
              id="singleFixedGate-4"
              type="image/svg+xml"
              className={`peer tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 ${
                activeTool === 'singleFixedGate-4' ? `!fill-header hover:fill-header` : 'hover:fill-slate-900'
              }`}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 66.4 72"
            >
              <g>
                <path d="M66.4,62.3c0,3,0,6,0,9c0,0.2-0.5,0.7-0.7,0.7C44,72,22.4,72,0.7,72C0.5,72,0,71.5,0,71.3c0-23.5,0-47,0-70.5   C0,0.5,0.5,0,0.7,0C3.5,0,6.3,0,9.1,0c0.3,0.2,0.7,0.4,1,0.5c1.9,0.4,3.9,0.7,5.9,1.1C26,3.7,34.6,8.4,42.5,14.8   c7.3,6,13,13.3,17.2,21.8c2.9,5.9,4.9,12,5.7,18.5C65.6,57.5,66,59.9,66.4,62.3z M6.9,33.5c0,10,0,20,0,29.9c0,1.3,0.2,1.8,1.7,1.8   c18-0.1,36,0,54,0c1.4,0,1.6-0.5,1.6-1.7c0.1-5.6-0.9-11-2.4-16.2c-2.6-8.9-7-17-13.3-23.9C37.7,11.5,24.5,4.2,8.5,2.3   C7.1,2.1,6.8,2.4,6.8,3.7C6.9,13.6,6.9,23.6,6.9,33.5z" />
              </g>
            </svg>

            <div
              class="hidden justify-evenly items-center peer-hover:flex flex-row hover:flex
         w-[200px]
          bg-white absolute h-12 left-10 !z-[991]"
            >
              <svg
                onClick={() => {
                  setActiveTool('rotate-2');
                  $.event.trigger({
                    type: 'switchTool',
                    tool: 'rotate-2'
                  });
                }}
                id="singleFixedGate-4"
                type="image/svg+xml"
                className={`tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 ${
                  activeTool === 'rotate-2' ? `!fill-header hover:fill-[${require('../config.json').primary}]` : 'hover:fill-slate-900'
                }`}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 66.4 72"
              >
                <g>
                  <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M65.3,16.9c-0.8,6.5-2.8,12.6-5.7,18.5c-4.2,8.5-9.8,15.8-17.2,21.8C34.6,63.6,26,68.3,16,70.4c-1.9,0.4-3.9,0.7-5.9,1.1   c-0.4,0.1-0.7,0.3-1,0.5c-2.8,0-5.6,0-8.4,0C0.5,72,0,71.5,0,71.3c0-23.5,0-47,0-70.5C0,0.5,0.5,0,0.7,0C22.4,0,44,0,65.7,0   c0.2,0,0.7,0.5,0.7,0.7c0,3,0,6,0,9C66,12.1,65.6,14.5,65.3,16.9z M6.8,68.3c0,1.3,0.3,1.6,1.7,1.4c16-2,29.2-9.2,39.9-21.1   c6.3-6.9,10.6-15,13.3-23.9c1.6-5.3,2.6-10.7,2.4-16.2c0-1.2-0.3-1.7-1.6-1.7c-18,0-36,0-54,0c-1.4,0-1.7,0.5-1.7,1.8   c0,10,0,20,0,29.9C6.9,48.4,6.9,58.4,6.8,68.3z"
                  />
                </g>
              </svg>
              <svg
                onClick={() => {
                  setActiveTool('rotate-3');
                  $.event.trigger({
                    type: 'switchTool',
                    tool: 'rotate-3'
                  });
                }}
                id="singleFixedGate-4"
                type="image/svg+xml"
                className={`tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 ${
                  activeTool === 'rotate-3' ? `!fill-header hover:fill-[${require('../config.json').primary}]` : 'hover:fill-slate-900'
                }`}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 66.4 72"
              >
                <g>
                  <path d="M0,9.7c0-3,0-6,0-9C0,0.5,0.5,0,0.7,0C22.4,0,44,0,65.7,0c0.2,0,0.7,0.5,0.7,0.7c0,23.5,0,47,0,70.5c0,0.2-0.5,0.7-0.7,0.7   c-2.8,0.1-5.6,0-8.4,0c-0.3-0.2-0.7-0.4-1-0.5c-1.9-0.4-3.9-0.7-5.9-1.1c-9.9-2.1-18.6-6.8-26.4-13.1c-7.3-6-13-13.3-17.2-21.8   c-2.9-5.9-4.9-12-5.7-18.5C0.8,14.5,0.4,12.1,0,9.7z M59.5,38.5c0-10,0-20,0-29.9c0-1.3-0.2-1.8-1.7-1.8c-18,0.1-36,0-54,0   c-1.4,0-1.6,0.5-1.6,1.7c-0.1,5.6,0.9,11,2.4,16.2c2.6,8.9,7,17,13.3,23.9c10.7,11.9,23.9,19.1,39.9,21.1c1.4,0.2,1.7-0.1,1.7-1.4   C59.5,58.4,59.5,48.4,59.5,38.5z" />
                </g>
              </svg>
              <svg
                onClick={() => {
                  setActiveTool('rotate-4');
                  $.event.trigger({
                    type: 'switchTool',
                    tool: 'rotate-4'
                  });
                }}
                id="singleFixedGate-4"
                type="image/svg+xml"
                className={`tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 ${
                  activeTool === 'rotate-4' ? `!fill-header hover:fill-[${require('../config.json').primary}]` : 'hover:fill-slate-900'
                }`}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 66.4 72"
              >
                <g>
                  <path d="M1.1,55.1c0.8-6.5,2.8-12.6,5.7-18.5c4.2-8.5,9.8-15.8,17.2-21.8c7.8-6.4,16.5-11,26.4-13.1c1.9-0.4,3.9-0.7,5.9-1.1   c0.4-0.1,0.7-0.3,1-0.5c2.8,0,5.6,0,8.4,0c0.3,0,0.7,0.5,0.7,0.7c0,23.5,0,47,0,70.5c0,0.2-0.5,0.7-0.7,0.7C44,72,22.4,72,0.7,72   C0.5,72,0,71.5,0,71.3c0-3,0-6,0-9C0.4,59.9,0.8,57.5,1.1,55.1z M59.5,3.7c0-1.3-0.3-1.6-1.7-1.4c-16,2-29.2,9.2-39.9,21.1   c-6.3,6.9-10.6,15-13.3,23.9c-1.6,5.3-2.6,10.7-2.4,16.2c0,1.2,0.3,1.7,1.6,1.7c18,0,36,0,54,0c1.4,0,1.7-0.5,1.7-1.8   c0-10,0-20,0-29.9C59.5,23.6,59.5,13.6,59.5,3.7z" />
                </g>
              </svg>
            </div>
          </div>
          {/* <svg
            onClick={() => {
              setActiveTool("rotate-2");
              $.event.trigger({
                type: "switchTool",
                tool: "rotate-2",
              });
            }}
            id='singleFixedGate-4'
            type="image/svg+xml"
            className={`tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 ${
              activeTool === "rotate-2"
                ? `!fill-header hover:fill-header`
                : "hover:fill-slate-900"
            }`}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 66.4 72'
          >
            <g>
              <path
                xmlns='http://www.w3.org/2000/svg'
                d='M65.3,16.9c-0.8,6.5-2.8,12.6-5.7,18.5c-4.2,8.5-9.8,15.8-17.2,21.8C34.6,63.6,26,68.3,16,70.4c-1.9,0.4-3.9,0.7-5.9,1.1   c-0.4,0.1-0.7,0.3-1,0.5c-2.8,0-5.6,0-8.4,0C0.5,72,0,71.5,0,71.3c0-23.5,0-47,0-70.5C0,0.5,0.5,0,0.7,0C22.4,0,44,0,65.7,0   c0.2,0,0.7,0.5,0.7,0.7c0,3,0,6,0,9C66,12.1,65.6,14.5,65.3,16.9z M6.8,68.3c0,1.3,0.3,1.6,1.7,1.4c16-2,29.2-9.2,39.9-21.1   c6.3-6.9,10.6-15,13.3-23.9c1.6-5.3,2.6-10.7,2.4-16.2c0-1.2-0.3-1.7-1.6-1.7c-18,0-36,0-54,0c-1.4,0-1.7,0.5-1.7,1.8   c0,10,0,20,0,29.9C6.9,48.4,6.9,58.4,6.8,68.3z'
              />
            </g>
          </svg> */}
          {/* <svg
            onClick={() => {
              setActiveTool("rotate-3");
              $.event.trigger({
                type: "switchTool",
                tool: "rotate-3",
              });
            }}
            id='singleFixedGate-4'
            type="image/svg+xml"
            className={`tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 ${
              activeTool === "rotate-3"
                ? `!fill-header hover:fill-header`
                : "hover:fill-slate-900"
            }`}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 66.4 72'
          >
            <g>
              <path d='M0,9.7c0-3,0-6,0-9C0,0.5,0.5,0,0.7,0C22.4,0,44,0,65.7,0c0.2,0,0.7,0.5,0.7,0.7c0,23.5,0,47,0,70.5c0,0.2-0.5,0.7-0.7,0.7   c-2.8,0.1-5.6,0-8.4,0c-0.3-0.2-0.7-0.4-1-0.5c-1.9-0.4-3.9-0.7-5.9-1.1c-9.9-2.1-18.6-6.8-26.4-13.1c-7.3-6-13-13.3-17.2-21.8   c-2.9-5.9-4.9-12-5.7-18.5C0.8,14.5,0.4,12.1,0,9.7z M59.5,38.5c0-10,0-20,0-29.9c0-1.3-0.2-1.8-1.7-1.8c-18,0.1-36,0-54,0   c-1.4,0-1.6,0.5-1.6,1.7c-0.1,5.6,0.9,11,2.4,16.2c2.6,8.9,7,17,13.3,23.9c10.7,11.9,23.9,19.1,39.9,21.1c1.4,0.2,1.7-0.1,1.7-1.4   C59.5,58.4,59.5,48.4,59.5,38.5z' />
            </g>
          </svg>
          <svg
            onClick={() => {
              setActiveTool("rotate-4");
              $.event.trigger({
                type: "switchTool",
                tool: "rotate-4",
              });
            }}
            id='singleFixedGate-4'
            type="image/svg+xml"
            className={`tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 ${
              activeTool === "rotate-4"
                ? `!fill-header hover:fill-header`
                : "hover:fill-slate-900"
            }`}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 66.4 72'
          >
            <g>
              <path d='M1.1,55.1c0.8-6.5,2.8-12.6,5.7-18.5c4.2-8.5,9.8-15.8,17.2-21.8c7.8-6.4,16.5-11,26.4-13.1c1.9-0.4,3.9-0.7,5.9-1.1   c0.4-0.1,0.7-0.3,1-0.5c2.8,0,5.6,0,8.4,0c0.3,0,0.7,0.5,0.7,0.7c0,23.5,0,47,0,70.5c0,0.2-0.5,0.7-0.7,0.7C44,72,22.4,72,0.7,72   C0.5,72,0,71.5,0,71.3c0-3,0-6,0-9C0.4,59.9,0.8,57.5,1.1,55.1z M59.5,3.7c0-1.3-0.3-1.6-1.7-1.4c-16,2-29.2,9.2-39.9,21.1   c-6.3,6.9-10.6,15-13.3,23.9c-1.6,5.3-2.6,10.7-2.4,16.2c0,1.2,0.3,1.7,1.6,1.7c18,0,36,0,54,0c1.4,0,1.7-0.5,1.7-1.8   c0-10,0-20,0-29.9C59.5,23.6,59.5,13.6,59.5,3.7z' />
            </g>
          </svg> */}

          <svg
            onClick={() => {
              setActiveTool('house');
              $.event.trigger({
                type: 'switchTool',
                tool: 'house'
              });
            }}
            id="house"
            type="image/svg+xml"
            className={`tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 ${
              activeTool === 'house' ? `!fill-header hover:fill-header` : 'hover:fill-slate-900'
            }`}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="158.2 167.14 435.56 425.91"
          >
            {' '}
            <path
              d="m415.46 474.66c-0.097656-11.082-8.9766-19.734-19.914-19.734h-39.098c-11.105 0-19.82 8.8203-19.914 19.734l-0.003906-78.93h78.93zm-53.391-301.79c7.6914-7.6914 20.262-7.5938 27.855 0l195 195c15.387 15.387 10.156 27.859-11.703 27.859h-394.46c-21.852 0-27.164-12.398-11.703-27.859zm-163.66 222.86h138.12v177.68c0 10.848-8.6406 19.641-19.789 19.641h-98.547c-10.93 0-19.789-8.9922-19.789-19.641zm217.05 0h138.13v177.68c0 10.848-8.6406 19.641-19.789 19.641h-98.547c-10.93 0-19.793-8.9922-19.793-19.641z"
              fill-rule="evenodd"
            ></path>{' '}
          </svg>

          <svg
            onClick={() => {
              setActiveTool('pool');
              $.event.trigger({
                type: 'switchTool',
                tool: 'pool'
              });
            }}
            id="pool"
            type="image/svg+xml"
            className={`tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 ${
              activeTool === 'pool' ? `!fill-header hover:fill-header` : 'hover:fill-slate-900'
            }`}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="151.06 171.41 449.9 409.65"
          >
            {' '}
            <path d="m588.16 390.68c-7.1055 0-12.785 5.6836-12.785 12.785v44.516c-5.6836-1.8945-11.367-4.7344-16.102-9.4727-4.2617-4.2617-9.4727-6.6289-15.156-6.6289s-10.891 2.3672-15.156 6.6289c-7.1055 7.5781-17.051 11.84-26.992 11.84-9.9453 0-19.418-4.2617-26.992-11.84-0.47266-0.47266-1.4219-0.94531-1.8945-1.4219v-212.63c0-29.363-23.68-53.043-53.043-53.043s-53.043 23.68-53.043 53.043c0 7.1055 5.6836 12.785 12.785 12.785 7.1055 0 12.785-5.6836 12.785-12.785 0-15.156 12.312-27.469 27.469-27.469s27.469 12.312 27.469 27.469v61.094l-142.54-0.003906v-61.09c0-29.363-23.68-53.043-53.043-53.043s-53.043 23.68-53.043 53.043c0 7.1055 5.6836 12.785 12.785 12.785 7.1094 0 12.793-5.6836 12.793-12.785 0-15.156 12.312-27.469 27.469-27.469s27.469 12.312 27.469 27.469v213.59c-0.47266 0.47266-0.94531 0.47266-1.4219 0.94531-7.1055 7.5781-17.051 11.84-26.992 11.84-9.9453 0-19.418-4.2617-26.992-11.84-3.7891-4.2617-9.4727-6.6289-15.156-6.6289-5.6836 0-10.891 2.3672-15.156 6.6289-4.7344 5.2109-10.891 8.0508-17.051 9.9453v-44.988c0-7.1055-5.6836-12.785-12.785-12.785-7.1055 0-12.785 5.6836-12.785 12.785v164.33c0 7.1055 5.6836 12.785 12.785 12.785h424.33c7.1055 0 12.785-5.6836 12.785-12.785v-164.34c0-7.1016-5.6836-13.258-12.789-13.258zm-143.02 48.305c-7.1055 7.5781-17.051 11.84-26.992 11.84-9.9453 0-19.418-4.2617-26.992-11.84-4.2617-4.2617-9.4727-6.6289-15.156-6.6289s-10.891 2.3672-15.156 6.6289c-7.1055 7.5781-17.051 11.84-26.992 11.84-9.9453 0-19.418-4.2617-26.992-11.84-0.94531-0.94531-1.8945-1.4219-3.3164-2.3672v-45.938h143.02v46.883c0.47266 0.47266-0.47656 0.94922-1.4219 1.4219zm2.3672-127.87v53.988h-142.55v-53.988zm-270.89 243.89v-80.035c11.84-1.8945 23.207-7.1055 32.203-15.629 11.84 10.891 26.52 16.574 41.676 16.574 15.629 0 30.309-5.6836 41.676-16.574 11.84 10.891 26.52 16.574 41.676 16.574 15.629 0 30.309-5.6836 41.676-16.574 11.84 10.891 26.52 16.574 41.676 16.574s30.309-5.6836 41.676-16.574c11.84 10.891 26.52 16.574 41.676 16.574 15.629 0 30.309-5.6836 41.676-16.574 8.9961 8.0508 19.418 13.262 31.258 15.629v80.035z"></path>{' '}
          </svg>
          <svg
            onClick={() => {
              setActiveTool('tree');
              $.event.trigger({
                type: 'switchTool',
                tool: 'tree'
              });
            }}
            id="tree"
            type="image/svg+xml"
            className={`tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 ${
              activeTool === 'tree' ? `!fill-header hover:fill-header` : 'hover:fill-slate-900'
            }`}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="175.33 157.72 401.35 436.57"
          >
            {' '}
            <g>
              {' '}
              <path d="m251.33 459.16c1.4531-0.49219 3.0586-0.035156 4.0352 1.1484 9.3086 11.262 25.492 15.73 41.23 11.379 20.449-5.6562 33.242-24.285 29.129-42.418-0.29297-1.2852 0.12109-2.6289 1.0859-3.5273 8.5547-8.6172 12.188-20.191 9.7227-30.984-2.0352-8.9141-7.9023-16.422-16.508-21.137v-0.003906c-9.1133-4.7188-19.605-6.0547-29.613-3.7695-10.004 2.2891-18.875 8.0469-25.035 16.258l-0.097656 0.14062c-0.85547 1.2305-2.3633 1.8203-3.8242 1.5039-11.086-2.4062-23.512-2.1758-35.938 0.66406-31.957 7.3086-54.203 29.688-49.578 49.891 4.625 20.207 34.375 30.707 66.332 23.402 3.0586-0.69531 6.082-1.5469 9.0586-2.5469z"></path>{' '}
              <path d="m216.18 284.47c-20.582 3.3438-34.977 13.512-35.816 25.293-1.168 16.363 23.402 32.012 53.656 34.168 27.922 1.9922 52.527-7.6562 57.238-22.445 0.3125-0.97266 1.0078-1.7773 1.9297-2.2148 0.92188-0.44141 1.9844-0.48047 2.9375-0.11328 6.0078 2.3242 12.332 3.7305 18.762 4.1797 28.176 2.0156 53.551-14.465 59.031-38.324v-0.003907c0.40234-1.7305 1.9766-2.9375 3.7539-2.8672 1.7773 0.074219 3.2539 1.3984 3.5117 3.1562 2.4453 16.609 10.801 32.766 23.52 45.484v0.003906c8.0039 7.8086 17.438 14.004 27.785 18.242 4.75-15.484 19.973-26.852 37.98-26.852 1.5898 0 3.1797 0.089844 4.7578 0.26953 1.2969-6.5664 4.7188-12.52 9.7344-16.945 5.0195-4.4258 11.355-7.0742 18.027-7.5391 1.0312-7.5195 4.3672-14.535 9.5508-20.082 1.0156-20.441-8.8008-43.031-26.477-60.707-21.387-21.387-50.688-31.195-72.926-24.406-1.7383 0.53125-3.6055-0.28125-4.4023-1.9141-8.9102-18.246-30.555-31.172-55.152-32.922-16.559-1.1797-32.543 2.707-45.008 10.945-12.168 8.0391-19.648 19.359-21.07 31.879-0.15625 1.4023-1.0898 2.5938-2.4141 3.082-1.3203 0.48828-2.8047 0.1875-3.8359-0.77734-9.1914-8.0938-21.078-12.457-33.32-12.23-12.246 0.22656-23.965 5.0273-32.848 13.457-8.8867 8.4258-14.297 19.875-15.168 32.09-1.125 15.965 5.5898 31.473 18.004 41.57 1.1289 0.92188 1.6172 2.418 1.2422 3.8242-0.37891 1.4102-1.543 2.4648-2.9844 2.6992z"></path>{' '}
              <path d="m448.96 439.73c6-3.5312 10.973-8.5703 14.426-14.613 0.91016-1.6094 1.6914-3.2852 2.3359-5.0195-8.5898-3.8398-15.348-10.875-18.836-19.617-0.94922 2.1914-2.0234 4.3242-3.2188 6.3906-1.3047 2.3203-3.1992 4.2578-5.5 5.6055-2.2969 1.3516-4.9102 2.0664-7.5742 2.0742-2.0469-0.003906-4.0703-0.40625-5.9609-1.1836-3.4727-1.3359-6.3281-3.9062-8.0195-7.2148-1.6953-3.3125-2.1055-7.1328-1.1562-10.727l10.176-41.348c-6.3828-2.9844-12.422-6.6523-18.016-10.938l-11.152 25.812c-1.5 3.4883-4.4961 6.1172-8.1523 7.1523-3.6914 1.0547-7.6602 0.38281-10.805-1.8203-9.4297-6.7383-20.129-11.5-31.449-13.996-6.5117-1.3633-12.32-5.0078-16.383-10.277-4.0586-5.2695-6.1055-11.816-5.7656-18.461l0.035157-0.79688c-1.4688 0.09375-2.9492 0.14062-4.4414 0.14062-1.707 0-3.4219-0.0625-5.1484-0.18359h0.003906c-5.9492-0.41797-11.824-1.5703-17.492-3.4336-2.5 4.7734-6.1133 8.875-10.539 11.953 25.125 14.613 48.211 32.48 68.652 53.145 3.4609 3.5234 4.4844 8.7773 2.5977 13.344-1.8828 4.5664-6.3086 7.5703-11.25 7.6328-1.1328-0.003906-2.2617-0.16406-3.3555-0.46875-1.4844 4.8516-3.8203 9.3984-6.8984 13.434 12.969 7.543 26.84 19.113 30.137 40.648l0.53906 3.5c2.8945 18.672 5.8867 37.977 0.023438 56.684-4.5078 14.387-13.676 28.102-28.031 41.934-4.3477 4.1875-18.648 16.855-28.754 25.211 39.66-0.050781 132.36-0.070313 176.64-0.070313l-27.715-20.66c-20.984-15.645-32.758-39.711-34.039-69.605-0.96875-22.547 0.89453-50.211 24.09-64.227z"></path>{' '}
              <path d="m565.49 326.23c-0.8125-0.63672-1.3242-1.582-1.4102-2.6094-0.082031-1.0312 0.26562-2.0469 0.96484-2.8086 6.4297-6.7461 9.1641-16.207 7.3242-25.344-1.6328-7.7031-6.4102-14.375-13.176-18.406-7.0938-4.2891-15.562-5.7031-23.668-3.9492-14.508 3.0195-24.965 14.793-25.438 28.629-0.070313 2.6289-2.625 3.9297-5.0078 3.543-5.8672 0.003906-11.512 2.2422-15.781 6.2617s-6.8477 9.5195-7.2031 15.371c-0.070312 1.0742-0.60156 2.0625-1.457 2.7148-0.85156 0.65234-1.9453 0.90234-3 0.6875-2.3594-0.49609-4.7656-0.74219-7.1758-0.73828-17.715 0-32.125 13.32-32.125 29.695h-0.003907c0.082031 9.1172 4.4727 17.656 11.84 23.027 1.0195 0.74219 1.6055 1.9453 1.5547 3.207-0.39062 8.6523 3.0977 17.027 9.5078 22.852 6.4141 5.8242 15.086 8.4844 23.664 7.2617 8.5742-1.2188 16.16-6.1992 20.691-13.582 1.8008-3.1094 6.8125-1.7383 6.8633 1.7969h-0.003906c0.41797 9.7461 5.6914 18.637 14.047 23.676 8.3555 5.0391 18.68 5.5508 27.496 1.3672 8.8125-4.1836 14.945-12.508 16.324-22.168s-2.1758-19.367-9.4648-25.852c-0.94922-0.79297-1.4414-2.0039-1.3164-3.2305 0.125-1.2266 0.85156-2.3125 1.9375-2.8984 8.6172-4.6836 14.293-13.395 15.105-23.168 0.80859-9.7734-3.3594-19.297-11.09-25.336z"></path>{' '}
              <path d="m347.1 500.97h0.17578-0.003906c1.9766 0 3.6016-1.5547 3.6953-3.5273 0.125-2.6836 0.14062-5.543 0.050781-8.4844-0.0625-2.043-1.7695-3.6484-3.8125-3.5859s-3.6484 1.7695-3.5859 3.8125c0.085937 2.7539 0.070312 5.4141-0.046875 7.9102-0.046875 0.98438 0.29688 1.9414 0.96094 2.668 0.66016 0.72656 1.582 1.1602 2.5664 1.207z"></path>{' '}
              <path d="m340.4 515.42c-4.2852 13.121-12.973 25.715-26.562 38.504l-0.003906-0.003906c-0.73047 0.66797-1.1641 1.6016-1.2031 2.5938-0.039062 0.99219 0.32031 1.957 1 2.6758 0.67969 0.72266 1.6211 1.1445 2.6133 1.1641 0.99219 0.023438 1.9492-0.35156 2.6602-1.043 14.516-13.656 23.848-27.262 28.527-41.594v-0.003906c0.3125-0.93359 0.24219-1.957-0.20312-2.8359-0.44141-0.88281-1.2188-1.5469-2.1562-1.8555-0.9375-0.30469-1.957-0.22266-2.8359 0.22656-0.87891 0.44922-1.5391 1.2305-1.8359 2.1719z"></path>{' '}
            </g>{' '}
          </svg>
          <svg
            onClick={() => {
              setActiveTool('arrow');
              $.event.trigger({
                type: 'switchTool',
                tool: 'arrow'
              });
            }}
            id="arrow"
            type="image/svg+xml"
            className={`tool !w-[25px] !h-[25px] !p-0 transform hover:scale-110 duration-100 ${
              activeTool === 'arrow' ? `!fill-header hover:fill-header` : 'hover:fill-slate-900'
            }`}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="139.21 180 473.6 391"
          >
            {' '}
            <defs>
              {' '}
              <clipPath id="a">
                {' '}
                <path d="m139.21 180h473.58v391h-473.58z"></path>{' '}
              </clipPath>{' '}
            </defs>{' '}
            <g clip-path="url(#a)">
              {' '}
              <path d="m601.62 348.06-155.91-155.9c-7.0859-7.457-16.887-11.738-27.172-11.871-10.289-0.13281-20.195 3.8945-27.473 11.164-7.2812 7.2734-11.312 17.176-11.191 27.465 0.125 10.289 4.3984 20.09 11.848 27.184l92.16 92.016h-306.5c-13.637 0-26.238 7.2773-33.059 19.086-6.8164 11.812-6.8164 26.363 0 38.172 6.8203 11.809 19.422 19.086 33.059 19.086h305.65l-91.309 91.449c-9.2383 9.7188-12.695 23.574-9.1133 36.496 3.5859 12.922 13.688 23.016 26.613 26.59 12.926 3.5703 26.777 0.10156 36.488-9.1484l155.91-155.9c7.1836-7.1406 11.207-16.863 11.176-26.992 0.023437-0.31641 0.023437-0.63281 0-0.94922 0.019531-0.3125 0.019531-0.62891 0-0.94531-0.003907-10.125-4.0234-19.832-11.176-26.996z"></path>{' '}
            </g>{' '}
          </svg>
        </div>
      </div>
    </div>
  );
}
